<template>
  <v-form ref="formRef" v-model="isValid">
    <!-- عنوان فروشگاه -->
    <v-text-field 
      v-model="form.title" 
      label="عنوان فروشگاه" 
      outlined 
      dense 
      :rules="[v => !!v || 'وارد کردن عنوان الزامی است', v => (v && v.length >= 3) || 'عنوان باید حداقل ۳ کاراکتر باشد']"
    />
    
    <!-- کلید خصوصی دیجی‌کالا -->
    <v-textarea 
      v-model="form.private_key" 
      label="کلید خصوصی (Private Key)" 
      outlined 
      dense 
      rows="5"
      dir="ltr" 
      :rules="keyRules"
      placeholder="-----BEGIN RSA PRIVATE KEY-----&#10;...&#10;-----END RSA PRIVATE KEY-----"
    />
    
    <!-- وضعیت فعال بودن -->
    <v-switch 
      v-model="form.active" 
      label="فعال بودن فروشگاه" 
      color="primary" 
      inset 
      dense 
      class="mt-0" 
    />

    <!-- عملیات‌های همگام‌سازی -->
    <div class="mt-2">
      <label class="text-caption grey--text">عملیات‌های فعال:</label>
      <v-chip-group 
        v-model="form.operations" 
        multiple 
        column 
        active-class="primary--text text--accent-4"
      >
        <v-chip filter value="sync_price">همگام‌سازی قیمت</v-chip>
        <v-chip filter value="sync_stock">همگام‌سازی موجودی</v-chip>
      </v-chip-group>
    </div>
  </v-form>
</template>

<script>
export default {
  name: "DigikalaForm",
  data: () => ({
    isValid: false,
    form: {
      title: "",
      private_key: "",
      operations: [],
      active: true
    },
    keyRules: [
      v => !!v || "وارد کردن کلید خصوصی الزامی است",
      v => /-----BEGIN[\s\S]+PRIVATE KEY-----[\s\S]+-----END[\s\S]+PRIVATE KEY-----/.test(v ? v.trim() : "") || "فرمت کلید نامعتبر است (باید شامل هدر و فوتر استاندارد BEGIN/END باشد)"
    ]
  }),
  watch: {
    isValid(val) {
      this.$emit("valid", val);
    }
  },
  methods: {
    setData(data) {
      if (!data) return;
      this.form.title = data.title || "";
      this.form.active = typeof data.active === "boolean" ? data.active : Boolean(data.active);
      this.form.operations = Array.isArray(data.operations) ? [...data.operations] : [];

      // استخراج connection (پوشش هم آبجکت و هم استرینگ احتمالی)
      const conn = typeof data.connection === "string" ? JSON.parse(data.connection || "{}") : (data.connection || {});
      this.form.private_key = conn.private_key || data.private_key || "";

      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.validate();
        }
      });
    },
    getData() {
      return {
        title: this.form.title ? this.form.title.trim() : "",
        type: "digikala",
        active: this.form.active,
        operations: this.form.operations || [],
        connection: {
          private_key: this.form.private_key ? this.form.private_key.trim() : ""
        }
      };
    }
  }
};
</script>
